import AuthService from '@/services/Auth';
import SSAuthService from '@/services/SelfServes/SSAuth';
import store from "@/store";

export const logout = {
    methods: {
        handleLogout() {
            this.$store.commit('clearError')
            this.$store.commit('setLoading', true)
            AuthService.logoutUser()
                .finally(() => {
                    this.$cookie.delete(this.$cookieName, {domain: this.$cookieDomainName})
                    this.$store.dispatch('removeUser')
                    this.$store.dispatch('removeTokens')
                    this.$router.push('/')
                    this.$store.commit('setLoading', false)
                })
        },
        handleSSLogout() {
            store.commit('setLoading', true);
            store.commit('ssClearProducts');
            store.commit('ssClearOrders');
            store.commit('ssClearShipper');
            SSAuthService.logout()
                .finally(() => {
                    const route = localStorage.getItem('ss_department_hash') ? `/self-serves/${localStorage.getItem('ss_department_hash')}` : '/self-serves';
                    localStorage.removeItem('ss_access_token');
                    localStorage.removeItem('ss_refresh_token');
                    this.$router.push(route);
                    this.$store.commit('setLoading', false);
                })
        }
    }
};